import { get } from '@kit/utils/APIV1.js'

export const covid19 = async() => {
  return get("covid-19")
}